import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

/* comp imports */
import PageTransition from "../components/PageTransition";
import BackArrow from "../components/BackArrow";
import PicnicGame from "./PicnicGame";

import { preloadImages } from "../utils/preloadImages";
import { allPicnicGameImages } from "./game-data/allPicnicGameImages";
import MainDisclaimerModal from "../components/modals/MainDisclaimerModal";

const PicnicGameWrapper = () => {
  const navigate = useNavigate();
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const handleRedirect = (pageName) => {
    navigate(pageName);
  };

  useEffect(() => {
    const images = preloadImages(allPicnicGameImages);
    let loadedCount = 0;

    images.forEach((img) => {
      img.onload = img.onerror = () => {
        loadedCount++;
        if (loadedCount === images.length) {
          setImagesLoaded(true);
        }
      };
    });
  }, []);

  if (!imagesLoaded) {
    return (
      <>
        <div className="loading-assets-screen">
          <div className="text-loader">
            <span>Loading</span>
            <span>Game</span>
            <span>Assets</span>
            <span>...</span>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <PageTransition />
      <BackArrow handleRedirect={handleRedirect} linkName="/games" />
      <PicnicGame handleRedirect={handleRedirect} />
      <MainDisclaimerModal />
    </>
  );
};

export default PicnicGameWrapper;
